import axios from 'axios';
import Loading from '../util/loading.js';
import { Toast } from 'vant';
import router from '../router';

/**
 * axios 配置
 */
axios.defaults.timeout = 30000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['source'] = 'ADMIN-PDA';
axios.defaults.withCredentials = true;


//Axios实现请求重试
axios.defaults.retry = 1; //重试次数
axios.defaults.retryDelay = 1000; //重试延时
axios.defaults.shouldRetry = (error) => true; //重试条件，默认只要是错误都需要重试


/* 请求拦截器（请求之前的操作） */
// axios.interceptors.request.use((req) => {
//     return req;
// }, err => Promise.reject(err));

/* 请求之后的操作 */
axios.interceptors.response.use((result) => {
  if (result && result.data.code && result.data.code !== 1000) {
    if ([4001, 4002].includes(result.data.code) > 0) {
      Toast.fail('无效的会话，或者会话已过期，请重新登录');
      setTimeout(() => {
        router.replace({ path: '/login'});
      }, 1000);
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。');
    } else {
      const message = result.data.message || '系统接口请求异常';
      Toast.fail(message);
      return Promise.reject(message);
    }
  } else {
    return result;
  }
}, (err) => {
  return Promise.reject(err);
});

/* 封装post方法 */
export function post(url, data = {}) {
  let token = localStorage.getItem("token");
  if (token) {
    axios.defaults.headers.post['loginToken'] = token;
  }
  return new Promise((resolve, reject) => {
    Loading.showLoading();
    axios.post("/api/" + url, data).then(response => {
      Loading.closeLoading();
      resolve(response.data);
    }).catch(err => {
      Loading.closeLoading();
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/http.js